import React from 'react';
import update from 'immutability-helper';
import i18next from "i18next";
import config from "config";

class MultiRowSelection extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      options: this.props.options
    }
  }

  toggleSelection(option) {
    const updatedOptions = this.state.options.map(currentOption => {
      if (currentOption.id == option.id) {
        return update(currentOption, { $merge: { selected: !currentOption.selected } });
      } else {
        return currentOption;
      }
    });

    this.setState( { options: updatedOptions } );
  }

  clearAll() {
    let newOptions = []
    this.state.options.forEach((option) => {
      if (option.selected) {
        option.selected = false
        newOptions[newOptions.length] = option
      } else {
        newOptions[newOptions.length] = option
      }
    });
    this.setState( { options: newOptions } );
  }

  selectAll() {
    let newOptions = []
    this.state.options.forEach((option) => {
      if (option.selected) {
        newOptions[newOptions.length] = option
      } else {
        option.selected = true
        newOptions[newOptions.length] = option
      }
    });
    this.setState( { options: newOptions } );
  }

  render() {
    const optionRows = this.state.options.map(option => (
      <li key={option.id} className={option.className == null ? null : option.className} onClick={() => this.toggleSelection(option)}>
        {option.icon ? (<img width='18' height='18' src={option.icon} />) : null}
        {option.name}
        <img style={{ display: option.selected ? 'inline' : 'none' }} width='18' height='18' src={`${config.WEB_BASE_URL}/images/icon/check_icon.svg`} />
      </li>
    ));

    return (
      <div>
        <div className='modal-filter-button-container'>
          <button className="btn btn-sm btn-default modal-filter-button split" onClick={() => this.selectAll()}> { i18next.t('select-all') } </button>
          <button className="btn btn-sm btn-default modal-filter-button split" onClick={() => this.clearAll()}> { i18next.t('clear-all') } </button>
        </div>
        <button className="btn btn-sm btn-default modal-filter-button" onClick={() => this.props.onApplyFilters(this.state.options)}> { i18next.t('apply-filters') } </button>
        <ul>
          {optionRows}
        </ul>
      </div>
    );
  }
}

export default MultiRowSelection;
